var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUserProfile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    rx: 6,
    fill: "#E4E6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4997 19.5835C29.1155 19.5835 26.3643 22.3347 26.3643 25.7189C26.3643 29.0385 28.9605 31.7252 32.3447 31.8414C32.448 31.8285 32.5513 31.8285 32.6288 31.8414C32.6547 31.8414 32.6676 31.8414 32.6934 31.8414C32.7063 31.8414 32.7063 31.8414 32.7193 31.8414C36.0259 31.7252 38.6222 29.0385 38.6351 25.7189C38.6351 22.3347 35.8838 19.5835 32.4997 19.5835Z",
    fill: "#18191A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.062 35.2772C35.4582 32.8747 29.5811 32.8747 25.9516 35.2772C24.3111 36.3751 23.407 37.8605 23.407 39.4493C23.407 41.0381 24.3111 42.5106 25.9386 43.5956C27.747 44.8097 30.1236 45.4168 32.5003 45.4168C34.877 45.4168 37.2536 44.8097 39.062 43.5956C40.6895 42.4976 41.5937 41.0251 41.5937 39.4235C41.5807 37.8347 40.6895 36.3622 39.062 35.2772Z",
    fill: "#18191A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUserProfile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-profile.bb37e8f1623c293b707d16bb80838eb7.svg";